






































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';
import _ from 'lodash';
import PromoDetailModal from '../modals/PromoDetailModal.vue';
import { Spinner } from 'vue-image-spinner2';

@Component({
    name: 'promos',
    data: function () {
        return {
            promosPage_: 1,
        };
    },
    components: {
        PromoDetailModal,
        Spinner,
    },
    filters: {},
    computed: {
        ...mapState('promos', ['allPromos', 'allPromosLoading', 'promosPerPage', 'promosPage', 'promosTotal']),
        ...mapState('promos', {
            allPromos: (state: any) => {
                const allPromos = state.allPromos.map((promo: any) => {
                    promo.visible = promo.visible ? 'Activa' : 'Inactiva';
                    return promo;
                });
                return allPromos;
            },
        }),
    },
})
export default class Promos extends Vue {
    public allPromos!: any;
    public allPromosLoading!: any;
    public promosPerPage!: any;
    public promosPage!: any;
    public promosPage_!: any;
    public promo_word_search: any = '';
    public promosTotal!: any;
    private activePromoLoaded: boolean = false;
    allPromosHeaders = [
        { thClass: 'th', key: 'id', label: 'Número' },
        { thClass: 'th', key: 'title', label: 'Título' },
        { thClass: 'th', key: 'visible', label: 'Estatus' },
        { thClass: 'th', key: 'edit', label: '' },
    ];

    setUrlPage(page: any) {
        this.$router.push({
            path: 'promotions',
            query: {
                ...this.$route.query,
                page,
            },
        });
        this.promosPage_ = page;
    }

    setUrlSearch(search: string) {
        search = search.trim();
        this.$router.push({
            path: 'promotions',
            query: {
                ...this.$route.query,
                search,
            },
        });
    }

    clearFilters() {
        this.promo_word_search = '';
        this.$router.push({
            path: 'promotions',
            query: {},
        });
        this.promosPage_ = 1;
    }

    onOpenPromoModal(id: string | null = null) {
        this.$store.dispatch('promos/getOne', id);
        setTimeout(() => {
            this.$bvModal.show('promo-detail-modal');
        }, 400);
    }

    @Watch('$route')
    getAllPromos() {
        const page = this.$route.query.page || 1;
        const search = this.$route.query.search || null;
        const promo_status_filter = this.$route.query.promo_status_filter || null;
        this.$store.dispatch('promos/getAll', {
            page,
            search,
            promo_status_filter,
        });
    }

    mounted() {
        this.getAllPromos();
        this.promosPage_ = 1;
    }
}
